import { Route } from '@angular/router';
import { RenderMode, ServerRoute } from '@angular/ssr';
import { AboutUsPageComponent } from './pages/about-us-page.component';
import { AcpSystemPageComponent } from './pages/acp-system-page.component';
import { AntBotProCncPageComponent } from './pages/antbot-pro-cnc-page.component';
import { EasyLeanKitPageComponent } from './pages/easy-lean-kit-page.component';
import { HomePageComponent } from './pages/home-page.component';
import { LayoutComponent } from './pages/layout.component';
import { MillBarFeederPageComponent } from './pages/mill-bar-feeder-page.component';
import { SuccessfullySubscribedPageComponent } from './pages/successfully-subscribed-page.component';
import { ROUTES_NAMES } from './utils/routes';
export const appRoutes: Route[] = [
    {
        path: '',
        component: LayoutComponent,
        title: 'Antonyco',
        children: [
            {
                path: ROUTES_NAMES.home,
                component: HomePageComponent,
                title: 'Antonyco | Prošlapeme vám cestu k průmyslové automatizaci',
            },
            {
                path: ROUTES_NAMES.millBarFeeder,
                component: MillBarFeederPageComponent,
                title: 'Antonyco | Mill bar feeder',
            },
            {
                path: ROUTES_NAMES.easyLeanKit,
                component: EasyLeanKitPageComponent,
                title: 'Antonyco | Easy lean kit',
            },
            {
                path: ROUTES_NAMES.antBotProCnc,
                component: AntBotProCncPageComponent,
                title: 'Antonyco | AntBot Pro CNC',
            },
            {
                path: ROUTES_NAMES.acpSystem,
                component: AcpSystemPageComponent,
                title: 'Antonyco | ACP System',
            },
            {
                path: ROUTES_NAMES.aboutUs,
                component: AboutUsPageComponent,
                title: 'Antonyco | O nás',
            },
            {
                path: ROUTES_NAMES.successfullySubscribed,
                component: SuccessfullySubscribedPageComponent,
                title: 'Antonyco | Uspěšně jste se přihlásili k odběru newsletteru',
            },
            {
                path: '**',
                redirectTo: ROUTES_NAMES.home,
            },
        ],
    },
];

export const serverRoutes: ServerRoute[] = [
    {
        path: '',
        renderMode: RenderMode.Prerender,
    },
    {
        path: ROUTES_NAMES.millBarFeeder,
        renderMode: RenderMode.Prerender,
    },
    {
        path: ROUTES_NAMES.easyLeanKit,
        renderMode: RenderMode.Prerender,
    },
    {
        path: ROUTES_NAMES.antBotProCnc,
        renderMode: RenderMode.Prerender,
    },
    {
        path: ROUTES_NAMES.acpSystem,
        renderMode: RenderMode.Prerender,
    },
    {
        path: ROUTES_NAMES.aboutUs,
        renderMode: RenderMode.Prerender,
    },
    {
        path: ROUTES_NAMES.successfullySubscribed,
        renderMode: RenderMode.Prerender,
    },
];
